<template>
  <div class="card">
    <div
      class="card-header"
      :class="headerClass"
      :style="headerStyle"
    >
      <slot name="header" />
    </div>
    <div
      class="card-block"
      :class="bodyClass"
      :style="bodyStyle"
    >
      <slot name="body" />
    </div>
    <div
      v-if="$slots['footer']"
      class="card-footer"
    >
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    headerClass: { type: String, default: '' },
    headerStyle: { type: String, default: '' },
    bodyClass: { type: String, default: '' },
    bodyStyle: { type: String, default: '' },
  },
};
</script>

<style scoped>
  .card {
    margin-bottom: 0px;
  }
  .card-header {
    padding: 14px;
  }
  .card-block {
    padding: 14px;
  }
</style>
